import icon from './icon';
import { jsx as _jsx } from "react/jsx-runtime";
const Icon = icon("0 0 20 17", "Double Chevron Left", /*#__PURE__*/_jsx("path", {
  d: "M14.08 4.15 9.72 8.49l4.36 4.36.7-.7-3.65-3.66 3.65-3.64-.7-.7z"
}), /*#__PURE__*/_jsx("path", {
  d: "M9.58 4.15 5.22 8.49l4.36 4.36.7-.7-3.65-3.66 3.65-3.64-.7-.7z"
}));
if (process.env.NODE_ENV !== 'production') Icon.displayName = "IconDoubleChevronLeft";
export default Icon;